export {
  generateDeepLink,
  isAllowedDomain,
  extractSubdomain,
  findMatchingPattern,
  applyParams,
  APP_LINK_LIST_URL,
} from './deepLink';
export type { AppLinkMap } from './deepLink';
export { default as useAppLinkMap } from './useAppLinkMap';
